import Fade from './Fade'
import Slide from './Slide'
import Switch from './Switch'
import None from './None'
import genTransition from './genTransition'

export default {
  Fade,
  Slide,
  Switch,
  None,
  genTransition,
}
